import { useEffect, useState } from "react";

const TypingText = ({
  text,
  speed = 50,
  chunkSize = 3,
  onCompleted,
  className,
}: {
  text: string;
  speed?: number;
  chunkSize?: number;
  onCompleted?: () => void;
  className?: string;
}) => {
  const [displayed, setDisplayed] = useState("");
  const [index, setIndex] = useState(0);

  // Split text into grapheme-safe array once
  const [chars] = useState(() => Array.from(text));

  useEffect(() => {
    if (index >= chars.length) {
      onCompleted?.();
      return;
    }

    const timeoutId = setTimeout(() => {
      const nextChunk = chars.slice(index, index + chunkSize).join("");
      setDisplayed((prev) => prev + nextChunk);
      setIndex((i) => i + chunkSize);
    }, speed);

    return () => clearTimeout(timeoutId);
  }, [text, index, chars, speed, chunkSize, onCompleted]);

  return <span className={className}>{displayed}</span>;
};

export default TypingText;
